import { AppliedFilterInterface, FilterInterface, Select } from '@shopify/polaris'
import { useCallback } from 'react'

import {
  DeliveryMethodType,
  deliveryMethodTypeLabels,
  deliveryMethodTypeOptions,
} from '../../delivery-details-edit-dialog/models-form'
import { SubscriptionFilter } from '../api'

export const useAddDeliveryMethodFilter = (
  filter: SubscriptionFilter,
  updateFilter: (newFilter: Partial<SubscriptionFilter>) => any,
  filters: FilterInterface[],
  appliedFilters: AppliedFilterInterface[]
) => {
  const setDeliveryMethod = useCallback(
    (delivery_method?: string) => updateFilter({ delivery_method }),
    [updateFilter]
  )
  const clearDeliveryMethod = useCallback(() => setDeliveryMethod(undefined), [setDeliveryMethod])

  filters.push({
    key: 'delivery_method',
    label: 'Delivery method',
    filter: (
      <Select
        label="Delivery method"
        labelHidden
        options={deliveryMethodTypeOptions}
        value={filter.delivery_method}
        onChange={setDeliveryMethod}
        placeholder="Select delivery method"
      />
    ),
  })

  if (filter.delivery_method) {
    appliedFilters.push({
      key: 'delivery_method',
      label: `Delivery method: ${
        deliveryMethodTypeLabels[filter.delivery_method as DeliveryMethodType]
      }`,
      onRemove: clearDeliveryMethod,
    })
  }
}
